import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as ApplicationSelectors from './application.selectors';
import { ApplicationActions } from './application.actions';
import { ApplicationModel } from '../../model';
import { Retrieve } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class ApplicationFacade {
  private readonly store = inject(Store);

  readonly accessToken$ = this.store.pipe(select(ApplicationSelectors.getAccessToken));
  readonly application$ = this.store.pipe(select(ApplicationSelectors.getApplication));
  readonly corppassCode$ = this.store.pipe(select(ApplicationSelectors.getCorpPassCode));
  readonly retrieve$ = this.store.pipe(select(ApplicationSelectors.getRetrieve));

  setAccessToken(accessToken: string): void {
    this.store.dispatch(ApplicationActions.setAccessToken({ accessToken }));
  }

  setApplication(application: ApplicationModel): void {
    this.store.dispatch(ApplicationActions.setApplication({ application }));
  }

  setCorpPassCode(corppassCode: string): void {
    this.store.dispatch(ApplicationActions.setCorppassCode({ corppassCode }));
  }

  setRetrieve(retrieve: Retrieve): void {
    this.store.dispatch(ApplicationActions.setRetrieve({ retrieve }));
  }
}
